import {LG_WIDTH} from "@main/helpers/const.js";

const MARGIN_TOP_SECTION = 120;

class SideNav {
    links = [];
    active = undefined;

    constructor(el) {
        this.el = el;
        this.links = Array.from(this.el.querySelectorAll(".js-side-nav-link"));
        this.programLayout = this.el.closest(".program-layout");
        this.programSections = this.programLayout.querySelectorAll(".js-program-section");
        this.active = this.links[0];
        this.active?.classList.add("active");

        this.setOnClickLinks();
        this.bindEventlisteners();
    }

    bindEventlisteners() {
        window.addEventListener("wheel", () => {
            let scrollDistance = window.scrollY;
        
            if (window.innerWidth > LG_WIDTH) {
                this.programSections.forEach((el, i) => {
                    if (el.offsetTop - MARGIN_TOP_SECTION <= scrollDistance) {
                        this.links.forEach((link) => {
                            if (link.classList.contains("active")) {
                                link.classList.remove("active");
                            }
                        });
                        
                        this.links[i].classList.add("active");
                    }
                });
            }
        });
    }

    setOnClickLinks = () => {
        this.links.forEach((link, index) => {
            link.addEventListener("click", () => this.onClickLink(index));
        });
    };

    onClickLink = (index) => {
        this.links.forEach(link => {
            link.classList.remove("active");
        })
        
        this.links[index].classList.add("active");
        this.programSections[index]?.scrollIntoView({block: "start", behavior: "smooth"});    
    };
}

document.querySelectorAll(".js-side-nav").forEach((elem) => new SideNav(elem));
